import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, ThemePalette } from '@angular/material';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ErrorDialogComponent } from 'src/app/components/dialog/error-dialog/error-dialog.component';
import { ErrorPadraoDialogComponent } from 'src/app/components/dialog/error-padrao-dialog/error-padrao-dialog.component';
import { MensagemDialogComponent } from 'src/app/components/dialog/mensagem-dialog/mensagem-dialog.component';
import { SuccessDialogComponent } from 'src/app/components/dialog/success-dialog/success-dialog.component';
import { Cr } from 'src/app/components/transferobjects/abertura-chamado/Cr';
import { Sistema } from 'src/app/model/sistema';
import { FormaSolicitacaoService } from 'src/app/service/forma-solicitacao/forma-solicitacao.service';
import { PadraoService } from 'src/app/service/padrao/padrao.service';
import { ServentiaService } from 'src/app/service/serventia/serventia.service';
import { SistemaService } from 'src/app/service/sistema/sistema.service';
import { isValidCpf } from 'src/app/utils/shared/cpfValidator';
import { environment } from 'src/environments/environment';
import { AbrirChamadoDTO } from '../../components/transferobjects/abertura-chamado/AbrirChamadoDTO';

@Component({
  selector: 'app-chamado-delegatario-erro-info',
  templateUrl: './chamado-delegatario-erro-info.component.html',
  styleUrls: ['./chamado-delegatario-erro-info.component.css']
})
export class ChamadoDelegatarioErroInfoComponent implements OnInit {

  @BlockUI() loading: NgBlockUI;
  @Input() recebeTipoChamado: any;
  @Output() enviarTipoChamado = new EventEmitter();



  recaptcha: ReCaptchaV3Service;

  erroFalhaInfoForm: FormGroup;
  tipoChamadoForm : FormGroup;
  
  validFormaSolicitacao = false;

  telMaskSubtituto : string;
  telMaskDelegatario: string;

  /* variáveis do "anexo erro" */
  msgNomeAnexoErroAnterior: String;
  msgErroAnexoAnterior: String;
  imgAnexoErro: any;

  /* variáveis do "anexo erro anterior" */
  msgErroAnexo: String;
  msgNomeAnexoErro: String;
  imgAnexoErroAnterior: any;
  nomeSistemas = new Array<Sistema>();
  grupoSelected = new Array<any>();

  chamadoDados: AbrirChamadoDTO;

  anexosErroFalhaInfo:any[] = [];
  anexosStage: any[] = []; 
  tamanhoPermitido: any = 19999854; //20971520;
  tamanhoLido = 0; 
  map = new Map();
 
 anexoErroFalhaInfoForm: FormGroup;
  
 element: HTMLElement;
 inputAnexo: HTMLInputElement;

 extensaoDeAnexo: string;
 chamadoAberto: String;

 arquivo: File;

 valorInput: any;
 progressBar: any = 0;
 resposta: any;
 valorDialog: any;

 count = 0
 counter = 1;

 mode: String = 'determinate';
 color: ThemePalette = 'primary';
 value = 0;   // 20000000
 bufferValue = ((20479854 * (0.0000010)) * 5); //20971520

  constructor(
              private router: Router,
              private formBuilder: FormBuilder, 
              private padraoService: PadraoService, 
              private dialog: MatDialog, 
              private toast: ToasterService,
              private formaSolicitacaoService: FormaSolicitacaoService,
              private sistemaService: SistemaService,
              private serventiaService : ServentiaService
              ) { }

  ngOnInit() {

    this.chamadoDados = new AbrirChamadoDTO();

    this.anexoErroFalhaInfoForm = this.formBuilder.group({
      anexoItem: this.formBuilder.array([this.criarMaisUmCampoAnexo()])
    });

    this.anexosErroFalhaInfo.push(this.formBuilder.group({ anexo: ['']}));
    this.tipoChamadoForm = this.formBuilder.group({
      tipoChamado:["", Validators.required]
    });

    this.erroFalhaInfoForm = this.formBuilder.group({  
        nomeSistema: ["", Validators.required],    
        nomeCompletoDelegatario: ["", [Validators.required,Validators.minLength(4), Validators.maxLength(100)]],      
        numeroCpfDelegatario: ['', Validators.compose([Validators.required, Validators.minLength(11), isValidCpf()])],
        emailDelegatario: ['', [Validators.required, Validators.email]],
        numeroTelefoneDelegatario: ["", [Validators.required, Validators.minLength(10)]],
        codigoFlag: [""],
        codigoCNSArecadacao : ["", [Validators.required]],
        municipio:[""],
        sigla:[""],
        denominacao:[""],
        cnpj: ['', Validators.compose([ Validators.minLength(14),Validators.required])],
        distrito : [""],
        status : ["" ],
        detalhe: ["", [Validators.required, Validators.minLength(25)]],
        
    });

    this.erroFalhaInfoForm.get('numeroTelefoneDelegatario').valueChanges.map(valor => valor.length).subscribe(length => {
      if (length < 11) {
        this.telMaskDelegatario = '(00) 0000-00000'
      }
      else {
        this.telMaskDelegatario = '(00) 00000-0000'
      }
    });

    this.erroFalhaInfoForm.get('emailDelegatario').valueChanges.subscribe(event => {
      this.erroFalhaInfoForm.get('emailDelegatario').setValue(event.toLowerCase(), {emitEvent: false});
   });
    this.carregarSistemas();
  }

  carregarSistemas(): void {
    this.loading.start('Aguarde um momento...');
    this.sistemaService.obterListaSistemas().subscribe(response => {
      this.nomeSistemas = response;
      this.loading.stop();
    }, (error) => {
      this.loading.stop();
      this.abrirRespostaErro(error);
    });
  }

  carregarServentia(cns):void {
    var codigoCns = 0;
    var codigoArrecadacao = 0;

    if(cns.value.codigoCNSArecadacao === '') {
      this.abrirMensaagemdialog("Insira um valor do CNS/ARRECADAÇÃO para realizar a consulta!","Validação de Formulário","Identificação de Serventia");
      return;
    }

    if (cns.value.codigoFlag == 'ARRECADACAO') {
        codigoCns = 0;
        codigoArrecadacao = cns.value.codigoCNSArecadacao;
    }else if (cns.value.codigoFlag == 'CNS') {
        codigoCns = cns.value.codigoCNSArecadacao;
        codigoArrecadacao = 0;
    }
    else {
      cns.value.codigoCNSArecadacao = '';
      this.abrirMensaagemdialog("Selecione o tipo de Consulta CNS ou Arrecadação!","Validação de Formulário","Identificação de Serventia");
      
      return;
    }

    this.loading.start('Aguarde um momento...');
    this.serventiaService.obterServentia(codigoCns,codigoArrecadacao).subscribe(response => {

      if(response != null && response.length > 0 ) {
        this.erroFalhaInfoForm.get('sigla').setValue(response[0].sigla);
        this.erroFalhaInfoForm.get('municipio').setValue(response[0].municipio);
        this.erroFalhaInfoForm.get('denominacao').setValue(response[0].denominacao);
        this.erroFalhaInfoForm.get('status').setValue(response[0].status);
        this.erroFalhaInfoForm.get('cnpj').setValue(response[0].cnpj);
        this.erroFalhaInfoForm.get('distrito').setValue(response[0].distrito);
      }else{
        this.erroFalhaInfoForm.get('codigoCNSArecadacao').setValue('');
        this.erroFalhaInfoForm.get('sigla').setValue('');
        this.erroFalhaInfoForm.get('municipio').setValue('');
        this.erroFalhaInfoForm.get('denominacao').setValue('');
        this.erroFalhaInfoForm.get('status').setValue('');
        this.erroFalhaInfoForm.get('cnpj').setValue('');
        this.erroFalhaInfoForm.get('distrito').setValue('');
        this.abrirMensaagemdialog("Código não encontrado !","Validação de Formulário","Identificação de Serventia");
      }
      this.loading.stop();
    }, (error) => {
      this.loading.stop();
      this.abrirRespostaErroPadrao(error.message);
    });
  }

  /* início evento para pegar o endereço do arquivo anexado em - tela erro */
  eventoAnexoErro(event: any): void {
    this.lerEventoErro(event.target);
  }

  lerEventoErro(inputValue: any): void {
    var anexoErro: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.imgAnexoErro = myReader.result;
      //this.nomeAnexoErro = anexoErro.name;
    }

    if (anexoErro.name.length > 50) {
      this.msgErroAnexo = 'Nome do arquivo muito extenso';
      this.msgNomeAnexoErro = '';
    }
    else if (anexoErro.size > 2253174) {
      this.msgErroAnexo = 'Tamanho máximo do arquivo foi excedido.';
      this.msgNomeAnexoErro = '';
    }
    else {
      this.msgNomeAnexoErro = anexoErro.name;
      this.msgErroAnexo = '';
      myReader.readAsDataURL(anexoErro);
    }
  }
  /* fim evento para pegar o endereço do arquivo anexado em - tela erro */

  /* início evento para pegar  o endereço do arquivo anexado em - tela anterior ao erro */
  eventoAdicionarAnexo(): any {
     if(this.count === 0) {
     //this.adicionarUmAnexo();
     this.count -= 1;
   } 
   return this.count;
 }

 eventoAdicionarErroFalhaInfoAnexo(): any {
  if(this.count === 0) {
   this.adicionarUmAnexoErroFalhaInfo();
   this.count -= 1;
 } 
 return this.count;
}

 /* início evento para pegar o endereço do arquivo anexado em - tela erro */

 eventoLeituraArquivo(event: any, id: any): any {
   this.lerArquivo(event.target, id);
   return this.arquivo;
 }
 /* Ler o aquivo anexado */
 lerArquivo(anexo: any, id: any) {

  const anexoExtensao: File = anexo.files[0];
  this.map.set('divAnexo'+id, anexo.files[0]);
  const extensoesNaoPermitidas = ['.exe', '.msi', '.zip', '.rar'];
  let nomeArquivo: string;
  nomeArquivo = anexoExtensao.name.toLowerCase();

  this.valorInput = (document.getElementById('valorAnexo'+id));
  this.valorInput.innerHTML = nomeArquivo;    
  this.tamanhoLido += anexo.files[0].size; 
  this.extensaoDeAnexo = nomeArquivo.substr(nomeArquivo.lastIndexOf('.'));
  
  if (extensoesNaoPermitidas.indexOf(this.extensaoDeAnexo) < 0) {
    if (this.tamanhoLido <  this.tamanhoPermitido) {
      this.msgNomeAnexoErroAnterior = nomeArquivo;
      this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
      this.inputAnexo = (document.getElementById('anexoInput'+id) as HTMLInputElement);
      this.inputAnexo.disabled = true;
    } else {
      this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
      this.removeInput('divAnexo'+id, anexo);
      this.toast.pop('warning', 'Soma total de arquivos excedida.');
      this.adicionarUmAnexoErroFalhaInfo();
    }
  }  else {
    this.toast.pop('warning', 'Extensão de arquivo não permitida');
    if(this.count===0) {
      this.removeInput('divAnexo'+id, anexo);
      //this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
      this.adicionarUmAnexoErroFalhaInfo();
  } else if (this.count > 0) {
     this.removeInput('divAnexo'+id, anexo); 
      //this.progressBar += (anexoExtensao.size * 0.0000010) * 5;
      this.adicionarUmAnexoErroFalhaInfo();
    }
  }
 }

  get erroFalha() {
    return this.erroFalhaInfoForm.controls;
  }


  resetForm() {
    console.log('Entrou');
    this.enviarTipoChamado.emit('OI');
  }

  limparErroFalhaInfoForm() {
    this.anexoErroFalhaInfoForm = null;
    this.progressBar = 0;
    this.tamanhoLido = 0;
    this.count = 0;
    this.counter = 1;
    this.anexosErroFalhaInfo = [];
    this.validFormaSolicitacao = false;
    this.tipoChamadoForm.get('tipoChamado').setValue('');
    this.ngOnInit();
  }

  abrirChamadoErroFalhaInfo() {
    let mChamado = new AbrirChamadoDTO();
    mChamado.cr =  new Cr(); 
    
    if(!(this.erroFalhaInfoForm.controls.nomeSistema.value ==='SCC') && this.erroFalhaInfoForm.controls.status.value ==='INATIVO'){
      this.abrirMensaagemdialog("Status INATIVO da Serventia, só é possivel abrir chamado para Sistema SCC","Validação de Formulário","Status Serventia/ Nome do Sistema");
      return;
    }
    
    mChamado.cr.category.id = environment.idcategoriaAdvogadoDelegatario; //'419160',
    mChamado.cr.customer.name = '';
    mChamado.cr.description = '\n\nDADOS DA SOLICITAÇÃO DE ABERTURA DE CHAMADO - Delegatário ( ' + this.tipoChamadoForm.get('tipoChamado').value +' )' 
      + '\n\n --> I - DESCRIÇÃO: ' 
      + '\n\n ----->> ' + this.erroFalhaInfoForm.controls.detalhe.value
      + '\n' 
      + '\n\n --> II - DETALHES SOBRE O CHAMADO:' 
      + '\n\n ----->> ' + 'Nome do Sistema: ' + this.erroFalhaInfoForm.controls.nomeSistema.value
      + '\n'
      + '\n\n --> III - IDENTIFICAÇÃO DO DELEGATÁRIO:'
      + '\n\n ----->> ' + 'Nome completo: ' + this.erroFalhaInfoForm.controls.nomeCompletoDelegatario.value
      + '\n\n ----->> ' + 'CPF: ' + this.erroFalhaInfoForm.controls.numeroCpfDelegatario.value
      + '\n\n ----->> ' + 'Email: ' + this.erroFalhaInfoForm.controls.emailDelegatario.value
      + '\n\n ----->> ' + 'Telefone: ' + this.erroFalhaInfoForm.controls.numeroTelefoneDelegatario.value
      + '\n'
      + '\n\n --> IV - IDENTIFICAÇÃO DA SERVENTIA:'
      + '\n\n ----->> ' + 'CNS/ARRECADAÇÃO: ' + this.erroFalhaInfoForm.controls.codigoCNSArecadacao.value
      + '\n\n ----->> ' + 'Município: ' + this.erroFalhaInfoForm.controls.municipio.value
      + '\n\n ----->> ' + 'Sigla: ' + this.erroFalhaInfoForm.controls.sigla.value
      + '\n\n ----->> ' + 'Denominação: ' + this.erroFalhaInfoForm.controls.denominacao.value
      + '\n\n ----->> ' + 'CNPJ: ' + this.erroFalhaInfoForm.controls.cnpj.value
      + '\n\n ----->> ' + 'Distrito: ' + this.erroFalhaInfoForm.controls.distrito.value
      + '\n\n ----->> ' + 'Status: ' + this.erroFalhaInfoForm.controls.status.value
      + '\n\n ';
      mChamado.cr.type.REL_ATTR = '';
      mChamado.cr.z_alt_phone_number = this.erroFalhaInfoForm.controls.numeroTelefoneDelegatario.value;
      mChamado.cr.cidade.id = '';
      mChamado.cr.lotacao.id = '';
      mChamado.cr.zs_email_preferencial = this.erroFalhaInfoForm.controls.emailDelegatario.value;
      mChamado.cr.group.name = 'COATE_SD_N1'; //'COATE_SD_N1';
      mChamado.email = this.erroFalhaInfoForm.controls.emailDelegatario.value;
      mChamado.sistema = this.erroFalhaInfoForm.controls.nomeSistema.value; 
      mChamado.codigoCNSArecadacao = this.erroFalhaInfoForm.controls.codigoCNSArecadacao.value;
      mChamado.codigoFlag = this.erroFalhaInfoForm.controls.codigoFlag.value;
      mChamado.nomeDelegatario = this.erroFalhaInfoForm.controls.nomeCompletoDelegatario.value

    if (this.erroFalhaInfoForm.invalid) {
      return; 
    }

    this.anexosErroFalhaInfo = [];
    for (let i = 0; i <= this.map.size; i++) {
      var arquivo = this.map.get('divAnexo' + i); 
      if(arquivo != undefined) {
        this.anexosErroFalhaInfo.push(this.map.get('divAnexo' + i));
      }
    }

    this.loading.start('Aguarde um momento...');
    this.padraoService.abrirChamadoErrofalhaInfo(JSON.stringify(mChamado), this.anexosErroFalhaInfo).subscribe(response => {
      this.chamadoAberto = response;
      this.loading.stop();
      this.abrirRespostaSucesso(response);
      this.limparErroFalhaInfoForm();
    }, (error) => {
      this.loading.stop();
      this.abrirRespostaErro(error);
    });
  }

  abrirRespostaSucesso(resposta: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { valor: resposta };
    dialogConfig.width = '600px';
    dialogConfig.height = '380px';
    dialogConfig.panelClass = 'custom-dialog';
    this.dialog.open(SuccessDialogComponent, dialogConfig);
  }

  abrirRespostaErro(resposta: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { valor: resposta };
    dialogConfig.width = '600px';
    dialogConfig.height = '380px';
    this.dialog.open(ErrorDialogComponent, dialogConfig);
  }

  abrirRespostaErroPadrao(resposta: any) {
    const dialogPadraoConfig = new MatDialogConfig();
    dialogPadraoConfig.autoFocus = true;
    dialogPadraoConfig.disableClose = true;
    dialogPadraoConfig.data = { valor: resposta };
    dialogPadraoConfig.width = '550px';
    dialogPadraoConfig.height = '350px';
    this.dialog.open(ErrorPadraoDialogComponent, dialogPadraoConfig);
  }

  abrirMensaagemdialog(resposta: any, titulo:any,subTitulo:any) {
    const mensagemDialog = new MatDialogConfig();
    mensagemDialog.autoFocus = true;
    mensagemDialog.disableClose = true;
    mensagemDialog.data = { valor: resposta, titulo: titulo,subTitulo:subTitulo };
    mensagemDialog.width = '550px';
    mensagemDialog.height = '400px';
    this.dialog.open(MensagemDialogComponent, mensagemDialog);
  }

  criarMaisUmCampoAnexo() {
    return this.formBuilder.group({ anexo: [''] })
  }

  limparInput(index, arquivo: any, id) {

    this.element = document.getElementById(index) as HTMLElement;

    var element2 = document.getElementById('anexoInput'+ id) as HTMLInputElement;
    element2.disabled = false;

    var element3 = document.getElementById('valorAnexo'+id) as HTMLInputElement;
    element3.innerHTML = '';
    if(arquivo.files[0].size> 0 ){
      
      if(this.progressBar > 0) {
        this.progressBar -= (arquivo.files[0].size * 0.0000010) * 5;
      }      
      this.tamanhoLido -= arquivo.files[0].size;
      this.map.delete(index);
    }
  }
  //arrayInputs = [{ anexo: ['a', Validators.required] }, { anexo: 'b' }];

  /*formName = this.formBuilder.group({
    controllerArray: this.formBuilder.array([])
  })*/

  /*setArrayInputs(arrayInputs) {
    const arrayFG = arrayInputs.map(address => this.formBuilder.group(address));
    const formArray = this.formBuilder.array(arrayFG);
    this.anexoForm.setControl('anexoItem', formArray);
  }*/

  adicionarUmAnexoErroFalhaInfo() {
    this.count++;
    this.counter++;
    (this.anexoErroFalhaInfoForm.get('anexoItem') as FormArray).push(this.formBuilder.group({ 
      anexo: ['']
    }))
    this.anexosErroFalhaInfo.push(this.formBuilder.group({ 
      anexo: ['']
    }));
  }

  removeInput(index, arquivo: any) {
    if (this.count == 0) {
      this.element = document.getElementById(index) as HTMLElement;
      this.element.hidden = true;
    }
    if (this.count > 0) {
      this.element = document.getElementById(index) as HTMLElement;
      this.element.hidden = true;
      this.count--;
    }
    if(this.progressBar > 0) {
      this.progressBar -= (arquivo.files[0].size * 0.0000010) * 5;
    }
    
    if(arquivo.files[0] !== undefined) {
      this.tamanhoLido -= arquivo.files[0].size;
    }    
    this.map.delete(index);
  }

  public removerEspaco(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.get(key).setValue(formGroup.get(key).value);
    });
  }
}
